import { render, staticRenderFns } from "./elichain.vue?vue&type=template&id=56bc83ec&scoped=true&"
import script from "./elichain.vue?vue&type=script&lang=js&"
export * from "./elichain.vue?vue&type=script&lang=js&"
import style0 from "./elichain.vue?vue&type=style&index=0&id=56bc83ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc83ec",
  null
  
)

export default component.exports